export const Colors = {
  // Figma-like palette
  overlayBrown: "#4A2311",
  white: "#FFFFFF",
  white60: "rgba(255,255,255,0.6)",
  white50: "rgba(255,255,255,0.5)",
  orange400: "#FB923C",
  orange500: "#F97316",
  orange600: "#EA580C",
  orangeText: "#FFEDD5",
  darkText: "#2B160B",

  // Buttons
  ghostBg: "rgba(255,255,255,0.10)",
  card: "rgba(255,255,255,0.92)",
};
